module.exports = __webpack_public_path__ + "img/co2.93ffb317.svg";